import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../datatable/DataTable";
import "../author/author.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";

const authorEditPath = "edit-client-logo";
const ListEndpoint = ApiEndpoints.clientLogo.List;
const DeleteEndpoint = ApiEndpoints.clientLogo.Delete;
const tableHeader = ["Logo","Country", "Status"];
const tbody = ["logo","country", "status"];

export default function ClientLogos() {

  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", ListEndpoint);
        const result = response.logos;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, []);

  const handleDelete = useCallback(
    async (logo_id) => {
      const payload = { logo_id };
      try {
        await ApiRequest("POST", DeleteEndpoint, payload);
        toast.success("Logo deleted successfully");
        setData((prevData) => prevData.filter((item) => item._id !== logo_id));
      } catch (error) {
        console.error("Error deleting author:", error);
      }
    },
    []
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Client Logos</h5>
      </div>
      <div className="add-author-section">
        <Link className="default-btn" to="/admin/add-client-logo">
          Add Client Logo
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={authorEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
